import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const previousAllowanceSlice = createSlice({
  name: "previousAllowance",

  initialState: {
    previousAllowance: [],
  },
  reducers: {
    setPreviousEmployeeAllowance: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.previousAllowance = payload;
    },

    resetPreviousEmployeeAllowance: (state: any) => {
      state = [];
    },
  },
});

export const { resetPreviousEmployeeAllowance, setPreviousEmployeeAllowance } =
  previousAllowanceSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default previousAllowanceSlice.reducer;
